import { ConfirmModal } from '@/components';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import invariant from 'tiny-invariant';
import { useDeleteReservedProject } from '../_hooks/reserved-project';

type Props = {
  selectedReservedProjectId: string | null;
  onClose: () => void;
};

export const ReservedProjectDeleteModal: FC<Props> = ({
  selectedReservedProjectId,
  onClose,
}) => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();

  const { mutateAsync: deleteReservedProject } = useDeleteReservedProject();

  return (
    <ConfirmModal
      open={!!selectedReservedProjectId}
      title={t('delete-confirmation')}
      disclaimerText={t('delete-confirmation-disclaimer')}
      onOk={async () => {
        invariant(!!selectedReservedProjectId, t('unreachable-code'));

        try {
          await deleteReservedProject(selectedReservedProjectId);
          await Promise.all([
            openMessage('success', t('message-delete-completed')),
            (async () => {
              onClose();
            })(),
          ]);
        } catch {
          await openMessage('error', t('message-delete-failed'));
        }
      }}
      onCancel={onClose}
      skipCheck
    />
  );
};
